export default {
  async dataURLtoFile (dataUrl) {
    const fetchResult = await fetch(dataUrl)

    return this.createFileFromBlob(
      await fetchResult.blob()
    )
  },

  createFileFromBlob (blob) {
    return new File([blob], `name_${Math.random()}`, {type: blob.type})
  },

  async validateDimensions (file, maxWidth, maxHeight, allowCropper = false) {
    return new Promise((resolve, reject) => {
      const _URL = window.URL || window.webkitURL

      const img = new Image()

      img.src = _URL.createObjectURL(file)

      img.onload = function () {
        const dimensionsRejectionReason = 'Image dose not match the dimensions'

        if (!allowCropper && this.width > maxWidth && this.height > maxHeight) {
          reject(dimensionsRejectionReason)
        } else if (this.width > maxWidth && this.height > maxHeight) {
          resolve('greater')
        } else if (this.width === maxWidth && this.height === maxHeight) {
          resolve('equal')
        } else {
          reject(dimensionsRejectionReason) // in case of smaller than allowed dims
        }
      }
    })
  },

  validateSize (file, maxSize) {
    return new Promise((resolve, reject) => {
      const size = file.size / 1024 / 1024 // in MB

      if (size > maxSize) {
        reject('File size is invalid')
      } else {
        resolve()
      }
    })
  },

  async getBase64OfFile (file) {
    return new Promise((resolve) => {
      if (typeof file === 'string') {
        resolve(file)
      } else {
        const reader = new FileReader()

        reader.addEventListener('load', () => {
          resolve(reader.result)
        })

        reader.readAsDataURL(file)
      }
    })
  },

  async checkVideoAspectRatio (file) {
    const video = document.createElement('video')
    const reader = new FileReader

    return new Promise((resolve, reject) => {
      reader.addEventListener('load', () => {
        video.addEventListener('loadedmetadata', () => {
          const aspectRatio = video.videoWidth / video.videoHeight

          if (
            (!video.videoHeight || !video.videoWidth) ||
            !([(16 / 9), (4 / 3)].includes(aspectRatio))
          ) {
            reject(false)
          } else {
            resolve(true)
          }
        })

        video.src = reader.result
      })

      reader.readAsDataURL(file)
    })
  },

  downloadVideo (videoUrl) {
    let name = videoUrl.split('/').pop()

    name = name.includes('.mp4') ? name : `${name}.mp4`

    fetch(videoUrl).then((t) => {
      t.blob().then((b) => {
        const a = document.createElement('a')

        a.href = URL.createObjectURL(b)

        a.setAttribute('download', name)

        a.click()
      })
    })
  },

  isAllowedImgFormat (file, allowedFormats) {
    return allowedFormats.includes(file.type)
  }
}
